import Axios, { AxiosRequestConfig } from 'axios';
import {
  URL_BACKEND_ROOT
} from "../app/AppConst";
import { BaseResponse } from '../dto/response/BaseResponse';
import { ReadResponse } from '../dto/response/ReadResponse';
import AuthUtility from '../util/AuthUtility';
import { PolicyEntity } from '../dto/policy/PolicyEntity';
import { PolicyModel } from '../dto/policy/PolicyModel';
import { PolicySearch } from '../dto/policy/PolicySearch';
import { ApiClient } from '../util/ApiUtility';

export const onPolicySubmit = async (policy: PolicyModel) => {
  const requestConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'PUT',
    url: `${URL_BACKEND_ROOT}` + '/v1/cms/policy',
    data: policy
  }

  let response = await ApiClient().request<BaseResponse<PolicyEntity>>(requestConfig);
  if (response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
      throw new Error("Амжилтгүй");
  }
}

export const onPolicySearch = async (data: PolicySearch) => {
    const requestConfig: AxiosRequestConfig = {
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'GET',
      url: `${URL_BACKEND_ROOT}` + '/v1/cms/policy',
      params: data
    }
    const response = await ApiClient().request<ReadResponse>(requestConfig);
    console.log(response);
    if (response.status >= 200 && response.status < 300) {
      return response.data;
    } else {
        throw new Error("Амжилтгүй");
    }
  }